export default "__VITE_ASSET__BU135cWT__"